export default __webpack_public_path__ + "static/media/seven_lc3.6e898679.png";